// 字节聚合替换域名
export const BYTEDANCE_REPLACEMENT_DOMAIN = {
	"rayjump.com":"mtgglobals.com",
	"mintegral.net":"mtgglobals.com",
	"mintegral.com":"mtgglobals.com",
}

// 埃及 EG 地区特殊域名
export const EG_REPLACEMENT_DOMAIN = {
	"rayjump.com":"mintegral.net"
}

// 埋点上报域名
export const ANALYTICS_DOMAIN = "https://analytics-h5.mintegral.net"

// 隐私政策地址 - cn
export const PRIVACY_URL_CN = "https://www.mintegral.com/cn/about_mintegral_ads/"

// 隐私政策地址 - en
export const PRIVACY_URL_EN = "https://www.mintegral.com/en/about_mintegral_ads/"